import React, { useState, useEffect, useCallback, useMemo } from "react";

import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Form, Formik } from "formik";

import toast, { Toaster } from "react-hot-toast";
import { Container } from "react-bootstrap";

import { bGId } from "common/constants/constants";

import {
  getBanksWithBranches,
  getRemainingBankslist,
} from "services/bankServices";
import { getProductList } from "services/ProductsServices";
import { createBranch } from "services/branchServices";

import SwiperSteps from "components/common/swiper/SwiperSteps";
import Step1 from "components/branches/addBranch/Step1";
import Step2 from "components/branches/addBranch/Step2";
import Step3 from "components/branches/addBranch/Step3";
import Loader from "components/common/loader/Loader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import "pages/branches/branches.scss";
import "common/common.scss";
import { useTranslation } from "react-i18next";
import Step4 from "components/branches/addBranch/Step4";
import { getSecretKey } from "./../../../services/bankServices";
import { encrypt } from "utils/Utils";
const AddBranch = () => {
  const bankgroupID = bGId;
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(1);
  const [bankList, setBankList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productsInitialValue, setProductsInitialValue] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [selectedBankName, setSelectedBankName] = useState("");
  const [banksWithBranchesList, setBanksWithBranchesList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [swiperSteps, setSwiperSteps] = useState([
    {
      id: 1,
      name: t("branch-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 2,
      name: t("user-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 3,
      name: t("products"),
      isError: false,
      isCompleted: false,
    },
    // {
    //   id: 3,
    //   name: t("payment-detail"),
    //   isError: false,
    //   isCompleted: false,
    // },
  ]);

  const handleSelectedBank = (bankName) => {
    setSelectedBankName(bankName);
  };

  const handleStepError = (stepId, isError) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isError = isError;
        }
        return step;
      });
      return updatedSteps;
    });
  };
  const handleStepCompletion = (stepId, isCompleted) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isCompleted = isCompleted;
        }
        return step;
      });
      return updatedSteps;
    });
  };

  const navigate = useNavigate();
  const handleNext = () => {
    setCurrentTab((pre) => pre + 1);
  };
  const handleBack = () => {
    setCurrentTab((pre) => pre - 1);
  };
  const handleJump = (tabId) => {
    setCurrentTab(tabId);
  };

  const validate = Yup.object({
    firstName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    lastName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    email: Yup.string().required(t("required")).email(t("email-error")),
    userFirstName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    userLastName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    userEmail: Yup.string().required(t("required")).email(t("email-error")),
    branchName: Yup.string(),
    location: Yup.string().required(t("required")),
    phoneNumber: Yup.number().required(t("required")),
    bankId: Yup.string().required(t("required")),
    bankGroupId: Yup.string().required(t("required")),
    // CreditEnabled: Yup.boolean(),
    // creditEntityId: Yup.string(),
    // sepaEnabled: Yup.boolean(),
    // SepaEntityId: Yup.string(),
    // accessToken: Yup.string(),
    // subscriptionPrice: Yup.number().positive(t("number-validation-message")),
  });

  const bankListSetter = async () => {
    let result = await getRemainingBankslist(bankgroupID);
    if (result?.success) {
      setBankList(result.payLoad);
    }
  };
  const fetchBanksWithBranches = async () => {
    let result = await getBanksWithBranches(bankgroupID);
    if (result?.success) {
      setBanksWithBranchesList(JSON.parse(result.payLoad.data)["banks"]);
    }
  };
  const productListSetter = async () => {
    let result = await getProductList();
    if (result?.success) {
      const newProductList = result.payLoad.items.map((el) => ({
        productName: el.productKey.replaceAll("#", "_"),
        ...el,
      }));
      const productsInitialValueNew = {};
      newProductList.forEach(
        (el) => (productsInitialValueNew[el.productName] = true)
      );
      setProductsInitialValue(productsInitialValueNew);
      setProductList(newProductList);
    }
  };

  useEffect(() => {
    (async () => {
      // await getPayloadSecretKey();
      await bankListSetter();
      await productListSetter();
      //await fetchBanksWithBranches();
      setShowForm(true);
    })();
  }, []);

  useEffect(() => {
    if (selectedBankName) {
      let filteredBranches = bankList.filter(
        (x) => x.bankName == selectedBankName
      );
      setBranchList(filteredBranches);
    } else setBranchList([]);
  }, [selectedBankName]);

  const handleSubmit = async (values, resetForm) => {
    setLoading(true);
    const params = { bankgroupsId: values.bankGroupId, bankId: values.bankId };
    const productIds = [];
    Object.keys(values)
      .filter((el) => el[0] === "_")
      .forEach((el) => {
        const foundProduct =
          productList.find(
            (product) => product.productName === el && values[el]
          ) || {};
        if (foundProduct?.productId) productIds.push(foundProduct.productId);
      });
    const data = {
      branch: {
        branchName: values.branchName,
        branchCode: "",
        branchLocation: values.location,
        contactPerson: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phoneNumber: values.phoneNumber,
        },
      },
      branchUser: {
        firstName: values.userFirstName,
        lastName: values.userLastName,
        email: values.userEmail,
      },
      productId: productIds,
      // bankPayment: {
      //   creditEnabled: values.creditEnabled,
      //   creditEntityId: encrypt(values.creditEntityId, secretKey),
      //   sepaEnabled: values.sepaEnabled,
      //   sepaEntityId: encrypt(values.sepaEntityId, secretKey),
      //   accessToken: encrypt(values.accessToken, secretKey),
      //   subscriptionPrice: values.subscriptionPrice,
      // },
    };

    const response = await createBranch(params, data);
    if (response.success) {
      setLoading(false);
      resetForm();
      navigate(`/branches/${response?.payLoad?.branch?.branchId}`, {
        state: values.bankId,
      });
    } else if (response.status === 422 || response.status === 400) {
      if (response?.data?.message === "Branch already exists") {
        toast.error(t('branchExists'));
      } else {
        toast.error(response?.data?.message);
      }
      setLoading(false);
    }
  };

  const initialValues = {
    bankGroupId: bankgroupID,
    bankId: "",
    branchName: "",
    location: "",
    firstName: "",
    lastName: "",
    email: "",
    userFirstName: "",
    userLastName: "",
    userEmail: "",
    phoneNumber: "",
    cotactPersonIsEA: false,
    ...productsInitialValue,
    creditEnabled: false,
    creditEntityId: "",
    sepaEnabled: false,
    sepaEntityId: "",
    accessToken: "",
    subscriptionPrice: "",
  };

  const renderCard = (formik) => {
    if (currentTab === 1) {
      return (
        <Step1
          formik={formik}
          bGId={bankgroupID}
          bankList={bankList}
          branchList={branchList}
          handleNext={handleNext}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
          handleSelectedBank={handleSelectedBank}
        />
      );
    } else if (currentTab === 2) {
      return (
        <Step2
          formik={formik}
          handleNext={handleNext}
          handleBack={handleBack}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    } else if (currentTab === 3) {
      return (
        <Step3
          formik={formik}
          handleBack={handleBack}
          handleNext={handleNext}
          loading={loading}
          productList={productList}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    }
    // else if (currentTab === 4) {
    //   return (
    //     <Step4
    //       formik={formik}
    //       loading={loading}
    //       handleBack={handleBack}
    //       productList={productList}
    //       handleCompletion={handleStepCompletion}
    //       handleError={handleStepError}
    //     />
    //   );
    // }
  };
  return (
    <Container className="p-5">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="custom-breadcrumbs ">
        <span
          className="breadcrumbs-item "
          onClick={() => {
            navigate("/branches");
          }}
        >
          {t("branches")}
        </span>
        <span className="breadcrumbs-item ">{t("add-branch")}</span>
      </div>

      <div className="d-flex justify-content-center ">
        <div className="shadow bg-body w-50 pt-3 pb-5 rounded">
          {showForm ? (
            <Formik
              initialValues={initialValues}
              validationSchema={validate}
              onSubmit={(values, { resetForm }) => {
                handleSubmit(values, resetForm);
              }}
            >
              {(formik) => {
                return (
                  <>
                    <SwiperSteps
                      list={swiperSteps}
                      tab={currentTab}
                      maxWidthSwiper={true}
                      back={handleBack}
                      next={handleNext}
                      jump={handleJump}
                    />
                    <Form className="">
                      <div className="px-5 py-2">{renderCard(formik)}</div>
                    </Form>
                  </>
                );
              }}
            </Formik>
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </Container>
  );
};

export default AddBranch;
